import Vue from "vue"
// import utils from '@/builder/utils'

const renderComponentCache = new Map()

function getContextData(ctx) {
  let n = ctx
  if (!ctx?.node) {
    n = window.api.getElementForName(ctx) || {}
    n.node = n
  }

  return { ...n.node, ...n.node.propsData, ...n, node: n.node || {}, api: window.api }
}

function getCachedRenderComponent(template) {
  let component = renderComponentCache.get(template)
  if (component) return component

  component = Vue.extend({
    props: ["context"],
    template,
    data() {
      return getContextData(this.context)
    },
    methods: {}
  })

  renderComponentCache.set(template, component)
  return component
}

export default Vue.component("RenderString", {
  props: [ 'string', 'expression', "context" ],
  // soporta 2 tipos distintos de expresiones:
  // string:      devuelve el string sin modificacion.
  // expression:  devuelve {{ expression }} tras evaluarlo como una expresion vue. Las expresiones de tipo __edad__ se sustituyen por el valor de edad en el formulario.
  // Si se indican ambos, solamente se usa expression.

  render(h) {
    // no mover estas lineas abajo porque esto crea una closure y si no es undefined cuando se ejecute data() ..


    if(this.expression == null) return h({template: this.string || ''})

    let usedString = this.expression || ''
    let e = usedString.startsWith('<') ? usedString: '<span>' + usedString + '</span>';
    const component = getCachedRenderComponent(e)

    return h(component, {
      props: {
        context: this.context
      }
    })
  }
})
